import { css } from 'styled-jsx/css';

export default css`
  .pc-model-sales-highlights-container {
    width: 474px;
    margin-left: 24px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    background: #141414;
    margin-bottom: 21px;
  }
  .pc-model-sales-highlights-image {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .pc-model-sales-highlights-list {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: start;
    gap: 12px;
    padding: 21px 21px;
  }
  .pc-model-sales-highlights-item {
    width: 100%;
    display: flex;
    justify-content: start;
    align-items: center;
    gap: 16px;
  }
  .pc-model-sales-highlights-item > span {
    width: 100%;
    font-family: 'Roboto-Medium';
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
  }
  @media (max-width: 1024px) {
    .pc-model-sales-highlights-container {
      display: none;
    }
  }
`;
